type LogLevel = 'debug' | 'info' | 'warn' | 'error';

interface LogEntry {
  level: LogLevel;
  message: string;
  timestamp: string;
  [key: string]: any;
}

class Logger {
  private isDevelopment = import.meta.env.MODE === 'development';

  private formatMessage(level: LogLevel, message: string, meta?: object): LogEntry {
    return {
      level,
      message,
      timestamp: new Date().toISOString(),
      ...meta
    };
  }

  private log(level: LogLevel, message: string, meta?: object) {
    const entry = this.formatMessage(level, message, meta);

    if (this.isDevelopment) {
      const consoleMethod = level === 'error' ? 'error' : 
                          level === 'warn' ? 'warn' : 
                          level === 'debug' ? 'debug' : 'log';
      
      console[consoleMethod](
        `[${entry.timestamp}] ${level.toUpperCase()}: ${message}`,
        meta ? meta : ''
      );
    }

    // In production, you might want to send logs to a service like Sentry
    if (!this.isDevelopment && (level === 'error' || level === 'warn')) {
      // TODO: Implement production logging (e.g., Sentry)
    }
  }

  debug(message: string, meta?: object) {
    this.log('debug', message, meta);
  }

  info(message: string, meta?: object) {
    this.log('info', message, meta);
  }

  warn(message: string, meta?: object) {
    this.log('warn', message, meta);
  }

  error(message: string, meta?: object) {
    this.log('error', message, meta);
  }
}

export const logger = new Logger();
